import { getCountryAlpha2, getCountryName } from "@helpers/countryHelpers";

export { getCountryAlpha2 };

/**
 * Name of a country in the current language.
 *
 * @param {object} country
 * @param {string} locale
 * @param {object[]} [countries] - the full list from the backend
 * @returns {string}
 */
export const getCountryLabel = (country, locale, countries) =>
  getCountryName(country, locale, countries);

/**
 * Options of the country dropdown sorted by the name in the current language.
 * key is the backend code (unique), value the two-letter code: several
 * backend entries share one (Cyprus, Akrotiri → CY). Search goes by the shown name, both backend names and the code.
 *
 * @param {object[]} countries - from the backend
 * @param {string} locale
 * @returns {{ key: string, value: string, label: string, searchText: string, country: object }[]}
 */
export const buildCountryOptions = (countries, locale) =>
  countries
    .map((country) => {
      const label = getCountryLabel(country, locale, countries);

      return {
        key: String(country.code || country.id || getCountryAlpha2(country)),
        value: getCountryAlpha2(country),
        label,
        searchText: [label, country.label_en, country.label_ru, country.code]
          .filter(Boolean)
          .join(" ")
          .toLowerCase(),
        country,
      };
    })
    .filter((option) => option.value)
    .sort((first, second) => first.label.localeCompare(second.label, locale));
